import React from 'react';
import BaseDetailPage from '../../_CustomComponents/BaseDetailPage';
import ReactToPrint from "react-to-print";
import { Navigate } from "react-router-dom";
import { Portlet, PortletBody, PortletHeader } from "../../../../partials/content/Portlet";
import PortletSpinner from '../../../../partials/layout/PortletSpinner';
import * as compensationEventCrud from '../../../../crud/compensationEvent.crud';
import * as quotationCrud from "../../../../crud/quotation.crud";
import * as fileCrud from '../../../../crud/file.crud';
import axios from 'axios';
import ActionModal from '../../_CustomComponents/ActionModal';
import DocumentMain from './DocumentMain';
import DocumentReply from './DocumentReply';
import QuotesRouter from '../quotes/Router';
import { TabPanel, Item } from 'devextreme-react/tab-panel';
import { Alert } from "react-bootstrap";
import { addDays } from 'date-fns';
import { ValidationSummary, ValidationGroup } from 'devextreme-react';
import moment from 'moment';
import Relations from '../../_CustomComponents/Relation/Relations';
import Common from '../../../../shared/common';
import { FormattedMessage } from "react-intl";
import PageToolbar from '../../_CustomComponents/PageToolbar';
import { withDetailPageProps } from '../../../../shared/hoc/withDetailPageProps';
import NavigationBlocker from '../../../../partials/Tools/NavigationBlocker';
import TemplateHelper from "../../../../Templates/TemplateHelper";
import * as relationshipCrud from '../../../../crud/relationship.crud';
import EmailNotifications from '../../_CustomComponents/EmailNotifications';
import NotificationContext from '../../../../../notificationContext';
const initialState = {
    notification: null,
    files: null,
    showModal: false,
    saving: false,
    // isDxFormValid: true,
    isChanged: false,
    //NEW REPLY STATES
    reply: null,
    replyFiles: null,
    isAwaitingReply: false,
    modalTitle: '',
    modalText: '',
    modalMode: '',
    relationCount: 0,
    postActionUrl: null,
    relations: null,
    selectedClause: null
}

class CompensationDetailPage extends BaseDetailPage {
    constructor(props) {
        super(props);
        this.isDevelopment = process.env.REACT_APP_ENVIRONMENT === 'DEV';
        this.isRelationsEnabled = process.env.REACT_APP_COMMUNICATION_REL_ENABLED === 'true' || process.env.REACT_APP_COMMUNICATION_TAG_ENABLED === 'true';
        this.printIssueDivRef = React.createRef();
        this.printAcceptanceDivRef = React.createRef();
        //NEW REPLY
        this.validatorRef = React.createRef();
        this.validatorName = 'CompensationValidator';

        this.state = { ...initialState };

    }

    static contextType = NotificationContext;

    componentDidMount() {
        this.fetchNotification();
        this.fetchFiles();
        this.fetchReplyFiles();
    }

    componentWillUnmount() {
        this.context.updateNotificationContext({
            documentIsFinal: false,
            path: null,
            referenceId: null,
            referenceType: null,
            workflowGroupId: null,
            workflowId: null,
        });
    }

    componentDidUpdate(prevprops, prevSatate) {
        if (this.props.params.notificationid !== prevprops.params.notificationid) {
            this.setState({ ...initialState }, () => {
                this.fetchNotification();
                this.fetchFiles();
                this.fetchReplyFiles();
            });
        }
    }

    getMailDescription = () => {
        return this.state.notification.compensationnumber;
    }
    getSelectedTypeClauseDisplay = () => {
        return this.state.notification.compensationtype;
    }
    fetchNotification = () => {
        compensationEventCrud.getCompensationEvent(this.props.params.notificationid)
            .then(response => {
                const compensation = response.data;
                if (compensation.contractid !== this.props.contract.contractid ||
                    compensation.compensationsource !== this.props.workflowItem.config.currentModelType) {
                    throw new Error(this.props.intl.formatMessage({ id: 'GENERAL.FORMS.INVALID_URL' }));
                }
                if (compensation.draftreplydate) {
                    compensation.draftreplydate = new Date(compensation.draftreplydate);
                }

                const awaitingReply = (compensation.showtasknotification === 1 && !compensation.contractorreceiveddate);
                const initialStatus = compensation.draftcestatus == null ? null : Number(compensation.draftcestatus);

                const replyItem = {
                    quoterequired: initialStatus,
                    eventcomment: compensation.draftreplycomment,
                    assumption: compensation.draftassumption,
                    faultpscp: compensation.draftfaultpscp === 1,
                    notexpectnothappen: compensation.draftnotexpectnothappen === 1,
                    noteffectcostcompletion: compensation.draftnoteffectcostcompletion === 1,
                    statedcontract: compensation.draftstatedcontract === 1,
                    notnotifiedwithintimescales: compensation.draftnotnotifiedwithintimescales === 1,
                    customfieldvalues: compensation.customfieldvalues
                };

                let selectedClause = null;
                let globalResources = this.props.globalResources;
                const { fields } = this.props.workflowItem;

                if (compensation.compensationtype && fields.Type.clauses) {
                    selectedClause = fields.Type.clauses.find(c => c.display === compensation.compensationtype);
                    if (selectedClause) {
                        globalResources = TemplateHelper.getGlobalResourcesOverriden(globalResources, selectedClause)
                    }
                    else {
                        if (compensation.showtasknotification !== 1) {
                            compensation.compensationtype = null;
                            this.props.enqueueSnackbar(this.props.intl.formatMessage({ id: 'GENERAL.FORMS.WARNING_CLAUSE_MISSING' }), { variant: 'warning', });
                        }
                    }
                }
                this.setState({
                    notification: compensation,
                    reply: replyItem,
                    isAwaitingReply: awaitingReply,
                    saving: false,
                    isChanged: false,
                    addedWarnings: [],
                    removedWarnings: [],
                    relations: compensation.relations,
                    relationCount: Common.GetRelationCount(compensation, this.props.accessibleWfIds),
                    selectedClause,
                    globalResources
                }, () => { 
                    this.props.setReference(this.state.notification.referenceid);
                    this.context.updateNotificationContext({
                        documentIsFinal: compensation.showtasknotification === 1,
                        path: this.props.location.pathname,
                        referenceId: this.props.params.notificationid,
                        referenceType: this.props.workflowItem.config.referenceType,
                        workflowGroupId: this.props.workflowGroupItem.id,
                        workflowId: this.props.workflowItem.id,
                    });
                });
            })
            .catch(err => {
                if (!axios.isCancel(err)) {
                    this.props.enqueueSnackbar(err.toString(), { variant: 'error', });
                }
            });
    }

    fetchFiles = async () => {
        try {
            const { companyid, projectid, contractid } = this.props.contract;
            const { documentType } = this.props.workflowItem.config;
            const { data } = await fileCrud.getContractNotificationFiles(companyid, projectid, contractid, this.props.params.notificationid, documentType)
            const filesList = JSON.parse(data.aggregatelist)
            this.setState({ files: filesList });
            return filesList;
        } catch (err) {
            if (!axios.isCancel(err)) {
                this.props.enqueueSnackbar(err.toString(), { variant: 'error', });
            }
        }
    }
    fetchReplyFiles = async () => {
        try {
            const { companyid, projectid, contractid } = this.props.contract;
            const { documentType } = this.props.workflowItem.config;
            const { data } = await fileCrud.getContractNotificationFiles(companyid, projectid, contractid, this.props.params.notificationid, documentType + 'Reply')
            const filesList = JSON.parse(data.aggregatelist)
            this.setState({ replyFiles: filesList });
            return filesList;
        } catch (err) {
            if (!axios.isCancel(err)) {
                this.props.enqueueSnackbar(err.toString(), { variant: 'error', });
            }
        }
    }
    printHandler = () => {
        this.printIssueRef.handlePrint();
    }
    printAcceptanceHandler = () => {
        this.printAcceptanceRef.handlePrint();
    }
    validateForm = () => {
        const validationResult = this.validatorRef.current.instance().validate();
        if (!validationResult.isValid) {
            this.props.enqueueSnackbar(this.props.intl.formatMessage({ id: 'GENERAL.FORMS.WARNING_MISSING_FIELDS' }), { variant: 'warning', });
        }
        return validationResult.isValid && !this.state.saving;
    }
    showModal = (mode, postActionNavigateObj) => {
        let selectedClause = null;
        const { fields } = this.props.workflowItem;

        if (this.state.notification.compensationtype && fields.Type.clauses) {
            selectedClause = fields.Type.clauses.find(c => c.display === this.state.notification.compensationtype);
        }
        if (mode === 'COMMUNICATE') {
            if (this.validateForm()) {
                let modalText = this.props.intl.formatMessage({ id: 'GENERAL.FORMS.WARNING_COMMUNICATING' }, { ITEM_NAME: this.props.title });
                modalText += " " + this.props.intl.formatMessage({ id: 'GENERAL.FORMS.WARNING_COMMUNICATING_APPEND' });
                this.setState({
                    showModal: true,
                    modalTitle: this.props.intl.formatMessage({ id: 'GENERAL.FORMS.BUTTON_COMMUNICATE_ITEM' }, { ITEM_NAME: this.props.title }),
                    modalText: modalText,
                    modalMode: mode,
                    postActionUrl: postActionNavigateObj,
                    selectedClause
                });
            }
        }
        else if (mode === 'SAVE_DRAFT') {
            if (this.validateForm()) {
                this.setState({
                    showModal: true,
                    modalTitle: this.props.intl.formatMessage({ id: 'GENERAL.FORMS.BUTTON_SAVE_DRAFT_NOTIFY' }),
                    modalText: this.props.intl.formatMessage({ id: 'GENERAL.FORMS.WARNING_DRAFT_SAVING' }),
                    modalMode: mode,
                });
            }
        }
        else if (mode === 'DELETE_DRAFT') {
            this.setState({
                showModal: true,
                modalTitle: this.props.intl.formatMessage({ id: 'GENERAL.FORMS.BUTTON_DELETE_DRAFT_NOTIFY' }),
                modalText: this.props.intl.formatMessage({ id: 'GENERAL.FORMS.WARNING_DRAFT_DELETING' }),
                modalMode: mode,
            });
        }
        else if (mode === 'REPLY_DRAFT') {
            //show reply tab
            this.tabPanel.instance().option("selectedIndex", 1);
            if (this.validateForm()) {
                this.setState({
                    showModal: true,
                    modalTitle: this.props.intl.formatMessage({ id: 'GENERAL.FORMS.BUTTON_SAVE_REPLY_DRAFT_NOTIFY' }),
                    modalText: this.props.intl.formatMessage({ id: 'GENERAL.FORMS.WARNING_DRAFT_SAVING' }),
                    modalMode: mode,
                });
            }
        }
        else if (mode === 'REPLY_SEND') {
            //show reply tab
            this.tabPanel.instance().option("selectedIndex", 1);
            if (this.validateForm()) {
                this.setState({
                    showModal: true,
                    modalTitle: this.props.intl.formatMessage({ id: 'GENERAL.FORMS.BUTTON_SEND_REPLY' }),
                    modalText: this.props.intl.formatMessage({ id: 'GENERAL.FORMS.WARNING_REPLY_SENDING' }),
                    modalMode: mode,
                    selectedClause
                });
            }
        }
    }

    onModalResponse = (response, params) => {
        this.setState({ showModal: false, saving: response === 'OK' }, async () => {
            try {
                if (response === 'OK') {
                    if (this.state.modalMode === 'COMMUNICATE') {
                        const notification = { ...this.state.notification };
                        notification.createactions = params?.createactions;
                        notification.completeactions = params?.completeactions;
                        notification.createby = this.props.contractUser.name;
                        notification.createbyid = this.props.contractUser.accountid;
                        notification.accountid = this.props.contractUser.accountid;
                        notification.status = this.props.workflowItem.replyEnabled ? 'APMR' : 'AQ';
                        notification.showtasknotification = 1;





                        let replyPeriod = this.props.workflowItem.replyPeriod;
                        const pmReplyRequired = moment(addDays(new Date(), replyPeriod)).format('DD/MM/YYYY');
                        notification.projectmanagersigneddatedisplay = pmReplyRequired;



                        const docBodyConfig = await this.documentBodyConfig(notification, this.props.resources);
                        const docConfig = await this.documentConfig(notification, docBodyConfig, this.props.contractUser.name, false, null, null, this.props.workflowItem.form_NotifyCompanyName);
                        notification.pdfjsoncontent = JSON.stringify(docConfig);

                        this.saveNotification(notification, this.state.modalMode);

                    }
                    else if (this.state.modalMode === 'SAVE_DRAFT') {
                        const notification = { ...this.state.notification };
                        if ((params || {}).userid) {
                            notification.lastdraftednotifiedto = params.userid;
                        }
                        notification.createby = this.props.contractUser.name;
                        notification.createbyid = this.props.contractUser.accountid;
                        notification.accountid = this.props.contractUser.accountid;
                        notification.status = 'NC';
                        notification.showtasknotification = 0;
                        this.saveNotification(notification, this.state.modalMode, params ? params.userid : null);

                    }
                    else if (this.state.modalMode === 'DELETE_DRAFT') {
                        const compensationevent = { ...this.state.notification };
                        const compensationeventid = compensationevent.compensationeventid
                        this.deleteCompensationEventDraft(compensationeventid);

                    }
                    else if (this.state.modalMode === 'REPLY_DRAFT') {
                        const reply = { ...this.state.reply };
                        const comp = { ...this.state.notification };

                        comp.draftcestatus = reply.quoterequired;
                        comp.draftreplycomment = reply.eventcomment;
                        comp.draftfaultpscp = reply.faultpscp && !reply.quoterequired ? 1 : 0;
                        comp.draftnotexpectnothappen = reply.notexpectnothappen && !reply.quoterequired ? 1 : 0;
                        comp.draftnoteffectcostcompletion = reply.noteffectcostcompletion && !reply.quoterequired ? 1 : 0;
                        comp.draftstatedcontract = reply.statedcontract && !reply.quoterequired ? 1 : 0;
                        comp.draftnotnotifiedwithintimescales = reply.notnotifiedwithintimescales && !reply.quoterequired ? 1 : 0;

                        comp.draftassumption = reply.quoterequired === 1 ? reply.assumption : '';
                        comp.draftreplystatus = 'Drafted';
                        comp.draftreplybyid = this.props.contractUser.accountid;
                        if ((params || {}).userid) {
                            comp.draftreplytoid = params.userid;
                        }
                        comp.draftreplydatedisplay = moment().format('DD/MM/YYYY');
                        for (let key in reply) {
                            if (key.startsWith("CF_")) {
                                comp[key] = reply[key];
                            }
                        }
                        this.saveNotification(comp, this.state.modalMode, (params || {}).userid);

                    }
                    else if (this.state.modalMode === 'REPLY_SEND') {
                        const reply = { ...this.state.reply };
                        if (!this.replyValidation(reply)) {
                            //FINAL REPLY FIELDS CHECK FAILED
                            throw new Error(this.props.intl.formatMessage({ id: 'GENERAL.FORMS.WARNING_REPLY_FIELDS_MISSING' }))
                        }

                        const comp = { ...this.state.notification };
                        comp.createactions = params?.createactions;
                        comp.completeactions = params?.completeactions;
                        comp.quoterequired = reply.quoterequired;
                        comp.eventcomment = reply.eventcomment;
                        comp.assumption = reply.quoterequired === 1 ? reply.assumption : '';

                        for (let key in reply) {
                            if (key.startsWith("CF_")) {
                                comp[key] = reply[key];
                            }
                        }
                        this.onSubmitReply(comp);

                    }
                }
            } catch (err) {
                this.props.enqueueSnackbar(err.toString(), { variant: 'error', });
                this.setState({ saving: false });
            }

        });

    }
    replyValidation = (reply) => {
        if (!reply.eventcomment) { return false; }
        return true;
    }

    getTaskURL = (notification) => {
        const { contractid, taskorderid } = notification;
        return `${window.location.origin}/contract/${contractid}/tasks/pm/${taskorderid}`;
    }

    getProjectURL = (notification) => {
        const { contractid, projectorderid } = notification;
        return `${window.location.origin}/contract/${contractid}/projects/pm/${projectorderid}`;
    }

    documentBodyConfig = async (notification, resources) => {
        // const { currentModelType } = this.props.workflowItem.config;
        const { fields } = this.props.workflowItem;
        const config = [];
        if (fields.Subject.visible) {
            config.push({ label: fields.Subject.label, value: notification.compensationnumber });
        }
        if (fields.Type.visible) {
            config.push({ label: fields.Type.label, value: notification.compensationtype });
        }

        if (fields.TaskOrder.visible) {
            config.push({ label: fields.TaskOrder.label, text: notification.taskorderreference ? notification.taskorderreference : "", valueType: 'LINK', url: this.getTaskURL(notification) });
        }
        if (fields.ProjectOrder.visible) {
            config.push({ label: fields.ProjectOrder.label, text: notification.projectorderreference ? notification.projectorderreference : "", valueType: 'LINK', url: this.getProjectURL(notification) });
        }
        if (fields.Note.visible) {
            config.push({ note: fields.Note.label, valueType: 'NOTE' });
        }
        if (fields.Description.visible) {
            config.push({ label: fields.Description.label, value: notification.description, valueType: 'HTML', align: 'vertical' });
        }


        if (fields.EarlyWarning.visible) {
            const { companyid, projectid, contractid } = this.props.contract;
            const { data: respData } = await compensationEventCrud.getCompensationWarnings(companyid, projectid, contractid, notification.compensationeventid)
            const relatedEWs = JSON.parse(respData.aggregatelist).map(ew => ({
                warningid: ew.earlywarningid,
                url: `${window.location.origin}/contract/${this.props.contract.contractid}/early-warning/${ew.earlywarningparty === "PM" ? "pm" : "supplier"}/${ew.earlywarningid}`,
                text: ew.earlywarningreferenceid + " " + ew.earlywarning
            }));

            config.push({
                label: fields.EarlyWarning.label,
                valueType: "LINKS",
                data: relatedEWs
            })
        }

        return config;
    }
    documentReplyBodyConfig = (notification, resources) => {
        const { fields, replyFields } = this.props.workflowItem;

        const replyOption = replyFields.ReplyStatus.replyOptions.find(opt => opt.value === notification.quoterequired);
        if (!replyOption) {
            this.props.enqueueSnackbar(`Reply option not found (${notification.quoterequired})`, { variant: 'error', });
            throw new Error();
        }
        const replyStatus = replyOption ? replyOption.display : `Reply option not found (${notification.quoterequired})`;

        const docConfig = [
            { label: replyFields.ReplyStatus.label, value: replyStatus },
        ];
        docConfig.push({ label: replyFields.ReplyComment.label, value: notification.eventcomment, valueType: 'HTML', align: 'vertical' });

        return docConfig;
    }
    onSubmitReply = async (compensation) => {
        const { companyid, contractid } = this.props.contract;

        compensation.projectmanagersignedbyid = this.props.contractUser.accountid;
        if (compensation.quoterequired === 1 || compensation.quoterequired === 2) {
            const { data: allQuotesList } = await quotationCrud.getQuotesReduced(companyid, contractid, compensation.compensationeventid);
            const replyPendingQuotes = allQuotesList.filter(Q => Q.responsestatus === 2);
            if (replyPendingQuotes && replyPendingQuotes.length > 0) {
                compensation.status = 'APMRQ';
            }
            else {
                compensation.status = 'AQ';
            }


        } else {
            compensation.status = 'R';
        }
        const newCompensation = { ...compensation };



        const docReplyBodyConfig = this.documentReplyBodyConfig(newCompensation, this.props.resources);
        const docReplyConfig = await this.documentConfig(newCompensation, docReplyBodyConfig, this.props.contractUser.name, true, null, null, this.props.workflowItem.form_ReplyCompanyName);
        newCompensation.pdfreplyjsoncontent = JSON.stringify(docReplyConfig);

        this.saveNotification(newCompensation, this.state.modalMode);
    }

    deleteCompensationEventDraft = async (compensationeventid) => {

        try {
            await compensationEventCrud.deleteCompensationEventDraft(compensationeventid);
            this.props.enqueueSnackbar(this.props.intl.formatMessage({ id: 'GENERAL.COMMUNICATON.DRAFT_DELETED' }), { variant: 'success' });
            this.setState({ saving: false, navigateto: this.props.workflowItem.paths.listPath });

        } catch (err) {
            this.props.enqueueSnackbar(err.toString(), { variant: 'error', });
            this.setState({ saving: false });
        }

    }
    saveNotification = async (notification, action, notifyuserid) => {
        // const { companyid, projectid, contractid } = this.props.contract;
        const postEvents = () => {
            this.fetchNotification();
            this.props.enqueueSnackbar(this.props.intl.formatMessage({ id: 'GENERAL.COMMUNICATON.SAVED_SUCCESS' }), { variant: 'success' });
        };
        try {
            if (!notification.projectmanagersigneddatedisplay && notification.projectmanagersigneddate) {
                notification.projectmanagersigneddatedisplay = moment(new Date(notification.projectmanagersigneddate)).format('DD/MM/YYYY');
            }

            if (!notification.draftreplydatedisplay && notification.draftreplydate) {
                notification.draftreplydatedisplay = moment(notification.draftreplydate).format('DD/MM/YYYY');
            }

            if (!notification.eventawaredatedisplay && notification.eventawaredate) {
                notification.eventawaredatedisplay = moment(notification.eventawaredate).format('DD/MM/YYYY');
            }


            //#TODO IN CEN Update
            if (this.state.addedWarnings && this.state.addedWarnings.length > 0) {
                notification.timeextension = this.state.addedWarnings[this.state.addedWarnings.length - 1].reference;
            }

            notification.actioncode = action;
            Common.PropertyConversionsBeforeNoticeSaveRequest(notification, this.props.customFields, this.props.contractUsers);
            await compensationEventCrud.saveCompensationEvent(notification);
            notification.notificationtypeforemailtemplate = notification.compensationsource;
            notification.pdfjsoncontent = notification.pdfjsoncontent?.replace("$NOW", moment().format('DD/MM/YYYY'));
            this.notify(action, notification, notifyuserid);
            if (this.state.postActionUrl) {
                this.setState({ isChanged: false, saving: false, navigateto: this.state.postActionUrl.pathname });
            } else {
                postEvents();
            }

        } catch (err) {
            this.setState({ saving: false });
            this.props.enqueueSnackbar(err.toString(), { variant: 'error', });
        }
    }
    fieldChanged = (field, value, isDxFormValid, additionalData) => {
        //SILENT STATE CHANGE
        //WE DONT WANT COMPONENT RERENDER WİTH THIS
        //this.setState({ notification: { ...this.state.notification, [field]: value } });
        if (field) {
            if (field === "assetid") {
                this.setState({
                    notification: { ...this.state.notification, [field]: value, asset: { ...additionalData } },
                    isChanged: true
                });
            }
            else if (field === 'compensationtype') {
                this.state.notification[field] = value;

                let selectedClause = null;
                let globalResources = this.props.globalResources;
                const { fields } = this.props.workflowItem;

                if (value) {
                    selectedClause = fields.Type.clauses.find(c => c.display === value);
                    if (selectedClause) {
                        globalResources = TemplateHelper.getGlobalResourcesOverriden(globalResources, selectedClause)
                    }
                }
                this.setState({
                    isChanged: true,
                    selectedClause,
                    globalResources
                })
            }
            else {
                this.state.notification[field] = value;
                if (!this.state.isChanged) {
                    this.setState({ isChanged: true });
                }
            }
        }


    }
    replyFieldChanged = (field, value, isDxReplyFormValid, isCheckBoxValue) => {
        //SILENT STATE CHANGE
        //WE DONT WANT COMPONENT RERENDER WİTH THIS
        //this.setState({ notification: { ...this.state.notification, [field]: value } });
        if (field) {
            this.state.reply[field] = value;
            if (!this.state.isChanged) {
                this.setState({ isChanged: true });
            }
        }

    }
    onCompensationChanged = () => {
        this.fetchNotification();
    }

    renderToolbar = (documentIsFinal) => {
        const saveDisabled = (this.state.saving || this.state.showModal || this.state.fileUploading);
        return (
            <PageToolbar
                key={this.state.notification.version}
                documentIsFinal={documentIsFinal}
                saveDisabled={saveDisabled}
                isAwaitingReply={this.state.isAwaitingReply}
                actions={{
                    showModal: this.showModal,
                    onPrintReply: this.printAcceptanceHandler,
                    onPrint: this.printHandler
                }}
                workflowItem={this.props.workflowItem}
                match={this.props.match}
                customFieldValues={this.state.notification.customfieldvalues}
                referenceid={this.state.notification.referenceid}
                contract={this.props.contract}
                relationParams={{
                    subject: this.getMailDescription(),
                    assetid: this.state.notification.assetid,
                    priceeffect: this.state.notification.assessmentamount,
                    timeeffect: this.state.notification.alternativequotation,
                    description: this.state.notification.description,
                }}
                notification={this.state.notification}
                selectedClausetypeDisplay={this.getSelectedTypeClauseDisplay()}
            />
        );
    }
    onWarningsChanged = async (addedWarningID, removedWarningID) => {
        try {
            if (addedWarningID) {
                const { companyid, projectid, contractid } = this.props.contract;
                const relationObj = {
                    companyid: companyid,
                    projectid: projectid,
                    contractid: contractid,
                    compensationeventid: this.state.notification.compensationeventid,
                    earlywarningid: null,
                };
                relationObj.earlywarningid = addedWarningID;
                await compensationEventCrud.saveCompensationEarlyWarning(relationObj)
                this.props.enqueueSnackbar(this.props.intl.formatMessage({ id: 'GENERAL.COMMUNICATON.RELATION_ADDED' }), { variant: 'success' });
            }
            else if (removedWarningID) {
                await compensationEventCrud.deleteCompensationEarlyWarning(this.state.notification.compensationeventid, removedWarningID);
                this.props.enqueueSnackbar(this.props.intl.formatMessage({ id: 'GENERAL.COMMUNICATON.RELATION_REMOVED' }), { variant: 'success' });
            }
            await this.updateRelations();
        } catch (err) {
            console.log(err);
            this.props.enqueueSnackbar(err.toString(), { variant: 'error', });
        }
    }
    updateRelations = async () => {
        try {
            const response = await relationshipCrud.getRelationships(this.props.params.notificationid, this.props.workflowItem.config.referenceType, this.props.contract.contractid)
            const newRelations = JSON.parse(response.data);
            this.setState({
                relations: newRelations,
                relationCount: Common.GetRelationCount({ relations: newRelations }, this.props.accessibleWfIds),
            })
        }
        catch (err) {
            console.log(err);
            this.props.enqueueSnackbar(err.toString(), { variant: 'error', });
        }
    }
    tabDocument = () => {
        if (!this.state.files) {
            return null;
        }
        else {
            return (
                <DocumentMain
                    {...this.props}
                    onWarningsChanged={this.onWarningsChanged}
                    printDivRef={this.printIssueDivRef}
                    fieldChanged={this.fieldChanged}
                    notification={this.state.notification}
                    files={this.state.files}

                    notificationid={this.props.params.notificationid}
                    saving={this.state.saving}
                    onFileUploadFinish={() => this.setState({ fileUploading: false })}
                    onFileUploadStart={() => this.setState({ fileUploading: true })}
                />
            );
        }

    }

    tabQuotes = () => {
        return (
            <QuotesRouter
                {...this.props}
                parentWorkflowItem={this.props.workflowItem}
                parentTabPanel={this.tabPanel}
                onCompensationChanged={this.onCompensationChanged}
                compensation={this.state.notification}
            />
        )
    }
    tabReply = () => {
        if (!this.props.workflowItem.userFilters.replyNotice.communicateReplyAllowed && !this.props.workflowItem.userFilters.replyNotice.saveDraftReplyAllowed && this.state.isAwaitingReply) {
            return (
                <div style={{ width: '100%', height: '100%', display: 'flex' }}>
                    <div style={{ width: '100%', maxWidth: '900px', margin: '20px' }}>
                        <Alert variant="warning" >
                            <p>
                                <FormattedMessage id="GENERAL.FORMS.WARNING_AWAITING_REPLY" values={{ ITEM_NAME: this.props.workflowItem.pageTitle }} />
                            </p>
                        </Alert>
                    </div>
                </div>
            )
        }
        else if (!this.state.isAwaitingReply && !this.state.notification.pdfreplyjsoncontent && this.state.notification.cendeemedacceptancedate) {
            //CEN HAS BEEN DEEM ACCEPTED
            //THERE IS NO REPLY DOCUMENT
            return (
                <div style={{ width: '100%', height: '100%', display: 'flex' }}>
                    <div style={{ width: '100%', maxWidth: '900px', margin: '20px' }}>
                        <Alert variant="warning" >
                            <p>
                                {this.props.resources.CenReplyMissingDueToDeemAcceptance}
                            </p>
                        </Alert>
                    </div>
                </div>
            )
        }
        else {
            return (
                <DocumentReply
                    {...this.props}
                    isAwaitingReply={this.state.isAwaitingReply}
                    printDivRef={this.printAcceptanceDivRef}
                    fieldChanged={this.replyFieldChanged}
                    notification={this.state.notification}
                    reply={this.state.reply}
                    files={this.state.replyFiles}
                    notificationid={this.props.params.notificationid}
                    globalResources={this.state.globalResources}
                    saving={this.state.saving}
                    onFileUploadFinish={() => this.setState({ fileUploading: false })}
                    onFileUploadStart={() => this.setState({ fileUploading: true })}
                />
            )
        }
    }
    tabRelations = () => {
        return (
            <Relations
                contractid={this.props.contract.contractid}
                workflowItem={this.props.workflowItem}
                workflowGroupItem={this.props.workflowGroupItem}
                notificationid={Number(this.props.params.notificationid)}
                relations={this.state.relations}
                itemversion={this.state.notification.version}
                subject={this.state.notification.compensationnumber}
                onCountChange={(count) => this.setState({ relationCount: count })}
                showTags={this.props.contract.specifictags?.length > 0}
                assetid={this.state.notification.assetid}
            />
        );
    }

    tabEmailNotification = () => {

        return (
            <EmailNotifications
                {...this.props}
                notificationDate={this.state.notification.notificationdate}
            />
        );

    };
    render() {
        if (!this.state.notification || !this.state.files || !this.state.replyFiles) {
            return (<PortletSpinner />);
        }

        const documentIsFinal = this.state.notification.showtasknotification === 1;
        let quotesTabEnabled = documentIsFinal; // always available 
        const replyTabEnabled = documentIsFinal && this.props.workflowItem.replyEnabled;

        if (!documentIsFinal && !this.props.workflowItem.userFilters.mainNotice.viewDraftAllowed) {
            return (<Navigate replace to={this.props.workflowItem.paths.listPath} />)
        }
        return (
            <Portlet>
                <ReactToPrint ref={el => (this.printIssueRef = el)} trigger={() => (<div style={{ display: 'none' }} ></div>)} content={() => this.printIssueDivRef.current} />
                <ReactToPrint ref={el => (this.printAcceptanceRef = el)} trigger={() => (<div style={{ display: 'none' }} ></div>)} content={() => this.printAcceptanceDivRef.current} />
                <PortletHeader
                    title={documentIsFinal ? this.props.workflowItem.pageTitle : this.props.intl.formatMessage({ id: "GENERAL.FORMS.DRAFT_TITLE" }, { ITEM_NAME: this.props.workflowItem.pageTitle })}
                    toolbar={this.renderToolbar(documentIsFinal)} />
                <NavigationBlocker
                    when={(this.state.isChanged || this.state.saving)}
                    message={this.props.intl.formatMessage({ id: 'GENERAL.FORMS.WARNING_UNSAVED' })}
                />
                {this.state.navigateto &&
                    (
                        <Navigate replace to={this.state.navigateto} state={(this.state.postActionUrl || {}).state} />
                    )
                }
                <PortletBody>
                    <ValidationGroup ref={this.validatorRef} name={this.validatorName}>
                        <div>
                            <ValidationSummary elementAttr={{ align: "right", paddingBottom: 50 }} id={this.validatorName}></ValidationSummary>
                        </div>
                        <TabPanel
                            ref={(ref) => this.tabPanel = ref}
                            width="100%"
                            deferRendering={false}
                            animationEnabled={true}
                            focusStateEnabled={true}
                            hoverStateEnabled={true}
                            swipeEnabled={false}>
                            <Item icon="file" title={this.props.title} render={this.tabDocument} />
                            {replyTabEnabled && <Item icon="rename" title={this.props.intl.formatMessage({ id: 'GENERAL.FORMS.TAB_REPLY' })} render={replyTabEnabled ? this.tabReply : null} visible={replyTabEnabled} />}
                            {quotesTabEnabled && <Item icon="sorted" title={this.props.intl.formatMessage({ id: 'GENERAL.FORMS.TAB_QUOTES' })} render={quotesTabEnabled ? this.tabQuotes : null} visible={quotesTabEnabled} />}
                            {
                                this.isRelationsEnabled && (
                                    <Item icon="share" title={this.props.intl.formatMessage({ id: 'GENERAL.FORMS.TAB_RELATIONS' })} render={this.tabRelations} badge={this.state.relationCount > 0 ? this.state.relationCount : null} />
                                )
                            }
                            <Item
                                icon="bulletlist"
                                title={this.props.intl.formatMessage({ id: 'GENERAL.FORMS.TAB_EMAIL_NOTIFICATIONS' })}
                                render={documentIsFinal ? this.tabEmailNotification : null} visible={documentIsFinal}
                            />
                        </TabPanel>
                    </ValidationGroup>
                </PortletBody>
                <ActionModal
                    visible={this.state.showModal}
                    title={this.state.modalTitle}
                    text={this.state.modalText}
                    mode={this.state.modalMode}
                    onDialogResult={this.onModalResponse}
                    workflowItem={this.props.workflowItem}
                    selectedClause={this.state.selectedClause}
                />
            </Portlet>
        );
    }
}

export default withDetailPageProps(CompensationDetailPage);